import type { CMSColumnLinksDTO } from "~/features/cms/types/dto";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { IconSize } from "~/common/components/icon/IconSize";
import { LinkList, LinkListItem } from "~/common/components/LinkList/LinkList";

interface Props extends Omit<CMSColumnLinksDTO, "type"> {
  className?: string;
}

export const CMSColumnLinks = (props: Props) => {
  return (
    <LinkList
      title={props.headline}
      titleIcon={props.icon && <Icon type={IconType[props.icon]} size={IconSize.FONT_24} />}
    >
      {props.links.map((link, index) => (
        <LinkListItem
          key={index}
          linkType={link.urlType}
          href={link.url}
          headline={link.title}
          subheadline={link.subtitle}
        />
      ))}
    </LinkList>
  );
};
